import { ScrollPosition } from "./types";

/**
 * Jméno modulu picasso. Slouží pro jednoznačnou identifikaci modulu.
 */
export const NAME = "PICASSO";

/**
 * Pomocná funkce pro vytvoření typu akce.
 * @param actionType Název typu akce.
 */
const createActionType = <N extends string>(actionType: N) => `${NAME}/${actionType}` as const;

/** Konstanty typů akcí */
export const LOAD_PICASSO_STATE = createActionType("LOAD_PICASSO_STATE");
export const SELECT_COMPONENT = createActionType("SELECT_COMPONENT");
export const UNSELECT_COMPONENT = createActionType("UNSELECT_COMPONENT");
export const UPDATE_COMPONENTS = createActionType("UPDATE_COMPONENTS");
export const DELETE_COMPONENTS = createActionType("DELETE_COMPONENTS");
export const SELECT_LINK = createActionType("SELECT_LINK");
export const UNSELECT_LINK = createActionType("UNSELECT_LINK");
export const UPDATE_LINKS = createActionType("UPDATE_LINKS");
export const SELECT_POINT = createActionType("SELECT_POINT");
export const UNSELECT_POINT = createActionType("UNSELECT_POINT");
export const CHANGE_SCALE_INDEX = createActionType("CHANGE_SCALE_INDEX");
export const UNSELECT_ALL = createActionType("UNSELECT_ALL");
export const SELECT_ALL_COMPONENTS = createActionType("SELECT_ALL_COMPONENTS");
export const REQUEST_PAINTING_SCROLL_POSITION = createActionType("REQUEST_PAINTING_SCROLL_POSITION");
export const UPDATE_COMPONENT_VISIBILITY = createActionType("UPDATE_COMPONENT_VISIBILITY");
export const UPDATE_COMPONENTS_ALIGNMENT = createActionType("UPDATE_COMPONENTS_ALIGNMENT");
export const UPDATE_COMPONENTS_RESIZE_OPTION = createActionType("UPDATE_COMPONENTS_RESIZE_OPTION");

export const PICASSO_PAINTING_CSS_CLASS = "picasso-painting";
export const PICASSO_PAINTING_BOX_CSS_CLASS = "picasso-painting-box";
export const PICASSO_PAINTING_WRAPPER_CSS_CLASS = "picasso-painting-wrapper";

/** Konstanta pro prázdné pole. Umožňuje porovnávání referencí. */
export const EMPTY_ARRAY: ReadonlyArray<any> = [];

/** Konstanta pro defaultní offset plátna picassa. */
export const DEFAULT_SCROLL_POSITION: ScrollPosition = { left: 0, top: 0 };

// Konstanty čísel tlačítek myši
export const CONST_NO_MOUSE_BTN = 0;
export const CONST_LEFT_MOUSE_BTN = 1;
export const CONST_RIGHT_MOUSE_BTN = 2;
export const CONST_MIDDLE_MOUSE_BTN = 4;

// Konstanty pro klávesy
export const CONST_ARROW_UP = "ArrowUp";
export const CONST_ARROW_DOWN = "ArrowDown";
export const CONST_ARROW_RIGHT = "ArrowRight";
export const CONST_ARROW_LEFT = "ArrowLeft";
export const CONST_F12_KEY = "F12";
export const CONST_F5_KEY = "F5";
export const CONST_TAB_KEY = "Tab";
export const CONST_SPACE_KEY = " ";

/** Seznam kláves, pro které v Picasso plátně preventujeme defaultní chování. */
export const PAINTINGS_PREVENTED_KEYS = [CONST_ARROW_LEFT, CONST_ARROW_RIGHT, CONST_ARROW_UP, CONST_ARROW_DOWN, CONST_SPACE_KEY];

// Konstanty maximálního/minimálního přiblížení
export const CONST_MAX_SCALE_INDEX = 2.0;
export const CONST_MIN_SCALE_INDEX = 0.3;
export const CONST_DEFAULT_SCALE_INDEX = 1.0;

/** Konstanta velikosti kroku přiblížení */
export const CONST_SCALE_STEP = 0.1;

/** Index pro kořenovou komponentu picassa */
export const CONST_ROOT_COMPONENT_INDEX = 0;

/** Konstanta pro nastavení tabindex. Nastaví element jako zaměřitelný a přidá ho do tab sequence. */
export const TAB_INDEX_FOCUSABLE_TAB_SEQUENCE = 0;
